module.exports = __webpack_public_path__ + "img/icon-white-check-solid.f2f15498.svg";